import { Tooltip as e } from "./primitive/index.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/tooltip/tooltip.tsx
var { Root: r, Trigger: i, Portal: a, Positioner: o, Popup: s, Arrow: c } = e, l = Object.assign(function({ trigger: e, content: l, showArrow: u = !0, triggerProps: d, popupProps: f, portalProps: p, positionerProps: m, arrowProps: h, ...g }) {
	return /* @__PURE__ */ n(r, {
		...g,
		children: [/* @__PURE__ */ t(i, {
			...d,
			children: e
		}), /* @__PURE__ */ t(a, {
			...p,
			children: /* @__PURE__ */ t(o, {
				...m,
				children: /* @__PURE__ */ n(s, {
					...f,
					children: [l, u && /* @__PURE__ */ t(c, { ...h })]
				})
			})
		})]
	});
}, {
	Root: r,
	Trigger: i,
	Portal: a,
	Positioner: o,
	Popup: s,
	Arrow: c
});
//#endregion
export { l as Tooltip };
